import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  useTheme,
  Divider,
  Snackbar,
  Alert,
  Grid,
  Card,
  CardContent,
  Typography,
  Avatar,
  Chip,
  CardActions,
  Button,
  Tooltip,
  CircularProgress,
  AvatarGroup,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  DialogTitle,
} from "@mui/material";
import { tokens } from "../../theme";
import { useState, useEffect } from "react";
import axios from "axios";
import { useUser } from "../../provider/AuthProvider";

import {
  Build,
  CheckCircle,
  Cancel,
  Edit,
  Wallpaper,
  Save,
} from "@mui/icons-material";
import { useSvgRef } from "@mui/x-charts";
const ServiceManagementPage = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { user } = useUser();
  const [isLoading, setIsLoading] = useState(false);
  const [defaultServices, setDefaultServices] = useState([]);
  const [editedService, setEditedService] = useState(null);
  const [previewLogo, setPreviewLogo] = useState(null);
  const fileInputRefs = useRef({});
  const [isUpload, setIsUpload] = useState(false);
  const [isSave, setIsSave] = useState(false);
  const [editDialog, setEditDialog] = useState({ open: false, service: null });
  const [addDialog, setAddDialog] = useState({
    open: false,
    name: "",
    description: "",
  });
  const [isAdding, setIsAdding] = useState(false);

  const [logoDialog, setLogoDialog] = useState({
    open: false,
    serviceId: null,
    selectedFile: null,
    previewUrl: null,
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    fetchServiceList();
  }, []);

  const fetchServiceList = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/compound/getDefaultServiceList/${user.id}`
      );
      console.log(res.data);
      setDefaultServices(res.data);
    } catch (error) {
      setSnackbar({
        open: true,
        message: t("sp_service.fetch_failed"),
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleSaveDialog = async () => {
    try {
      setIsSave(true);
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/compound/updateServiceInfo`,
        {
          serviceId: editDialog.service.id,
          userId: user.id,
          name: editDialog.service.name,
          description: editDialog.service.description,
        }
      );
      setSnackbar({
        open: true,
        message: t("sp_service.service_updated"),
        severity: "success",
      });
      closeEditDialog();
      fetchServiceList();
    } catch (err) {
      setSnackbar({ open: true, message: t("sp_service.update_failed"), severity: "error" });
    } finally {
      setIsSave(false);
    }
  };

  const openEditDialog = (service) => {
    setEditDialog({ open: true, service });
  };

  const closeEditDialog = () => {
    setEditDialog({ open: false, service: null });
  };

  const handleDialogChange = (e) => {
    setEditDialog((prev) => ({
      ...prev,
      service: { ...prev.service, [e.target.name]: e.target.value },
    }));
  };
  const handleAddService = async () => {
    setIsAdding(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/compound/createServiceType`,
        {
          name: addDialog.name,
          description: addDialog.description,
        }
      );

      setSnackbar({
        open: true,
        message: t("sp_service.service_created"),
        severity: "success",
      });

      setAddDialog({ open: false, name: "", description: "" });
      fetchServiceList(); // refresh services
    } catch (err) {
      console.error(err);
      setSnackbar({
        open: true,
        message: t("sp_service.create_failed"),
        severity: "error",
      });
    } finally {
      setIsAdding(false);
    }
  };

  // const handleSaveLogo = async (serviceId) => {
  //   setIsUpload(true);
  //   const file = fileInputRefs.current[serviceId]?.files[0];
  //   if (!file) {
  //     setIsUpload(false);
  //     setSnackbar({
  //       open: true,
  //       message: "Please select the Logo!",
  //       severity: "error",
  //     });
  //     return;
  //   }
  //   let logo_url;
  //   const formData = new FormData();
  //   formData.append("file", file);

  //   try {
  //     const res = await fetch(
  //       `${process.env.REACT_APP_BACKEND_URL}/api/upload/compound_logo`,
  //       { method: "POST", body: formData }
  //     );

  //     const data = await res.json();
  //     if (res.ok && data) {
  //       logo_url = data;
  //     } else {
  //       setSnackbar({
  //         open: true,
  //         message: t("sp_service.logo_upload_failed"),
  //         severity: "error",
  //       });
  //     }
  //     await axios.post(
  //       `${process.env.REACT_APP_BACKEND_URL}/api/compound/updateServiceLogo`,
  //       {
  //         servicetypeId: serviceId,
  //         userId: user.id,
  //         logoUrl: logo_url,
  //       }
  //     );

  //     setSnackbar({
  //       open: true,
  //       message: "Logo updaged successfully!",
  //       severity: "success",
  //     });
  //     setEditedService(null);
  //     setPreviewLogo(null);
  //     fetchServiceList();
  //   } catch (err) {
  //     setSnackbar({
  //       open: true,
  //       message: "Logo upload failed!",
  //       severity: "error",
  //     });
  //   } finally {
  //     setIsUpload(false);
  //   }
  // };

  // const handleLogoPreview = (event, serviceId) => {
  //   const file = event.target.files[0];
  //   if (!file) return;
  //   const url = URL.createObjectURL(file);
  //   setPreviewLogo({ serviceId, url });
  //   setEditedService(serviceId);
  // };

  const handleOpenLogoDialog = (service) => {
    setLogoDialog({
      open: true,
      serviceId: service.id,
      selectedFile: null,
      previewUrl: service.logo_url || null,
    });
  };

  const handleLogoFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const preview = URL.createObjectURL(file);
      setLogoDialog((prev) => ({
        ...prev,
        selectedFile: file,
        previewUrl: preview,
      }));
    }
  };

  const handleSaveLogoDialog = async () => {
    if (!logoDialog.selectedFile) {
      setSnackbar({
        open: true,
        message: t("sp_service.select_logo"),
        severity: "error",
      });
      return;
    }

    setIsUpload(true);

    const formData = new FormData();
    formData.append("file", logoDialog.selectedFile);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/upload/compound_logo`,
        { method: "POST", body: formData }
      );

      const data = await res.json();
      if (res.ok && data) {
        await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/compound/updateServiceLogo`,
          {
            servicetypeId: logoDialog.serviceId,
            userId: user.id,
            logoUrl: data,
          }
        );

        setSnackbar({
          open: true,
          message: t("sp_service.logo_updated"),
          severity: "success",
        });

        setDefaultServices((prevServices) =>
          prevServices.map((svc) =>
            svc.id === logoDialog.serviceId ? { ...svc, logo_url: data } : svc
          )
        );
        // fetchServiceList();
        setLogoDialog({
          open: false,
          serviceId: null,
          selectedFile: null,
          previewUrl: null,
        });
      } else {
        throw new Error("Upload failed");
      }
    } catch (err) {
      setSnackbar({
        open: true,
        message: t("sp_service.logo_upload_failed"),
        severity: "error",
      });
    } finally {
      setIsUpload(false);
    }
  };

  return (
    <Box className="main-container mt-4">
      {isLoading ? (
        <Box display="flex" justifyContent="center" py={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Box>
          <Button
            color="info"
            variant="contained"
            onClick={() =>
              setAddDialog({ open: true, name: "", description: "" })
            }
            sx={{ color: "#fff", p1: 2, m: 3, borderRadius: 4 }}
          >
            {t("sp_service.add")}
          </Button>

          <Grid
            container
            spacing={3}
            columns={{ xa: 12, sm: 12, md: 12 }}
            sx={{ m: 3 }}
          >
            {defaultServices?.map((service) => (
              <Grid item size={{ xa: 12, sm: 6, md: 4 }} key={service.id}>
                <Card
                  sx={{
                    borderRadius: 4,
                    boxShadow: 6,
                    transition: "transform 0.2s",
                    "&:hover": { transform: "scale(1.02)" },
                    display: "flex",
                    flexDirection: "column",
                    height: "300px",
                  }}
                >
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Box
                      display="flex"
                      alignItems="center"
                      gap={1}
                      mb={1}
                      justifyContent="space-between"
                    >
                      <Box display="flex" alignItems="center" gap={1}>
                        <Avatar
                          sx={{
                            bgcolor: colors.blueAccent[500],
                            width: 40,
                            height: 40,
                          }}
                        >
                          <Build fontSize="small" />
                        </Avatar>
                        <Typography variant="h6" fontWeight={600}>
                          {service.name}
                        </Typography>
                      </Box>
                      <Box display="flex" justifyContent="space-between">
                        <Chip
                          label={
                            service.isAvailable ? t("sp_service.available") : t("sp_service.unavailable")
                          }
                          color={service.isAvailable ? "success" : "error"}
                          icon={
                            service.isAvailable ? <CheckCircle /> : <Cancel />
                          }
                          size="small"
                        />
                      </Box>
                    </Box>

                    <Divider sx={{ my: 1 }} />

                    <Box mt={1} display="flex" alignItems="center" gap={1}>
                      <Typography
                        variant="h6"
                        color="text.secondary"
                        sx={{
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {service.description}
                      </Typography>
                    </Box>

                    <Box
                      mt={2}
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Box>
                        <Typography variant="subtitle2" gutterBottom>
                          {t("sp_service.providers")}
                        </Typography>
                        {service.ServiceProvider.length === 0 ? (
                          <Typography variant="body2" color="text.secondary">
                            {t("sp_service.no_providers_assigned")}
                          </Typography>
                        ) : (
                          <AvatarGroup max={3}>
                            {service.ServiceProvider.map((provider) => (
                              <Tooltip
                                key={provider.id}
                                title={
                                  <>
                                    <Typography fontWeight="bold">
                                      {provider.user.FullName}
                                    </Typography>
                                    <Typography variant="body2">
                                      {provider.user.email}
                                    </Typography>
                                    <Typography variant="body2">
                                      {provider.user.phone}
                                    </Typography>
                                  </>
                                }
                                arrow
                              >
                                <Avatar>
                                  {provider.user.FullName?.[0]?.toUpperCase() ||
                                    "U"}
                                </Avatar>
                              </Tooltip>
                            ))}
                          </AvatarGroup>
                        )}
                      </Box>

                      <Box display="flex" alignItems="center" gap={1}>
                        <Avatar
                          src={
                            previewLogo?.serviceId === service.id
                              ? previewLogo.url
                              : service.logo_url || undefined
                          }
                          variant="rounded"
                          sx={{
                            width: 100,
                            height: 100,
                            border: "1px solid #ccc",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            fileInputRefs.current[service.id]?.click()
                          }
                        >
                          {!service.logo_url && <Build fontSize="small" />}
                        </Avatar>

                        {/* <input
                          type="file"
                          accept="image/*"
                          ref={(el) => (fileInputRefs.current[service.id] = el)}
                          hidden
                          onChange={(e) => handleLogoPreview(e, service.id)}
                        />

                        <IconButton
                          size="small"
                          onClick={() =>
                            fileInputRefs.current[service.id]?.click()
                          }
                          color="primary"
                        >
                          <Edit fontSize="small" />
                        </IconButton> */}
                      </Box>
                    </Box>
                  </CardContent>

                  <CardActions
                    sx={{
                      mt: "auto",
                      px: 2,
                      py: 1,
                      justifyContent: "space-between",
                      borderTop: `1px solid ${colors.grey[300]}`,
                      backgroundColor: colors.primary[50],
                    }}
                  >
                    <Button
                      size="small"
                      variant="contained"
                      color="info"
                      startIcon={<Save />}
                      sx={{ color: "#fff" }}
                      onClick={() => handleOpenLogoDialog(service)}
                      // disabled={isUpload}
                    >
                      {t("sp_service.logo_change")}
                    </Button>
                    {/* <Button
                      size="small"
                      variant="contained"
                      color="info"
                      startIcon={<Save />}
                      sx={{ color: "#fff" }}
                      onClick={() => handleSaveLogo(service.id)}
                      disabled={isUpload}
                    >
                      Logo Change
                    </Button> */}
                    {!service.isDefault && (
                      <Button
                        size="small"
                        variant="contained"
                        startIcon={<Edit />}
                        color="error"
                        sx={{ color: "#fff" }}
                        onClick={() => openEditDialog(service)}
                      >
                        {t("sp_service.edit")}
                      </Button>
                    )}
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
      <Dialog
        open={logoDialog.open}
        onClose={() =>
          setLogoDialog({
            open: false,
            serviceId: null,
            selectedFile: null,
            previewUrl: null,
          })
        }
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>{t("sp_service.change_logo_title")}</DialogTitle>
        <DialogContent>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap={2}
          >
            {logoDialog.previewUrl && (
              <Avatar
                variant="rounded"
                src={logoDialog.previewUrl}
                sx={{ width: 120, height: 120, border: "1px solid #ccc" }}
              />
            )}
            <Button variant="outlined" component="label">
              {t("sp_service.change_logo_btn")}
              <input
                hidden
                type="file"
                accept="image/*"
                onChange={handleLogoFileChange}
              />
            </Button>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              setLogoDialog({
                open: false,
                serviceId: null,
                selectedFile: null,
                previewUrl: null,
              })
            }
          >
            {t("sp_service.cancel")}
          </Button>
          <Button
            onClick={handleSaveLogoDialog}
            variant="contained"
            disabled={isUpload}
          >
            {isUpload ? t("sp_service.saving") : t("sp_service.save")}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={editDialog.open}
        onClose={closeEditDialog}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>{t("sp_service.edit_service_title")}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label={t("sp_service.service_name")}
            fullWidth
            name="name"
            value={editDialog.service?.name || ""}
            onChange={handleDialogChange}
          />
          <TextField
            margin="dense"
            label={t("sp_service.service_description")}
            fullWidth
            multiline
            rows={3}
            name="description"
            value={editDialog.service?.description || ""}
            onChange={handleDialogChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeEditDialog}>{t("sp_service.cancel")}</Button>
          <Button
            variant="contained"
            onClick={handleSaveDialog}
            color="primary"
            disabled={isSave}
          >
            {isSave ? t("sp_service.saving") : t("sp_service.save")}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={addDialog.open}
        onClose={() => setAddDialog({ open: false, name: "", description: "" })}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>{t("sp_service.add_service_title")}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label={t("sp_service.service_name")}
            fullWidth
            value={addDialog.name}
            onChange={(e) =>
              setAddDialog((prev) => ({ ...prev, name: e.target.value }))
            }
          />
          <TextField
            margin="dense"
            label={t("sp_service.service_description")}
            fullWidth
            multiline
            rows={3}
            value={addDialog.description}
            onChange={(e) =>
              setAddDialog((prev) => ({ ...prev, description: e.target.value }))
            }
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              setAddDialog({ open: false, name: "", description: "" })
            }
          >
            {t("sp_service.cancel")}
          </Button>
          <Button
            onClick={handleAddService}
            variant="contained"
            disabled={isAdding || !addDialog.name.trim()}
          >
            {isAdding ? t("sp_service.adding") : t("sp_service.add")}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ServiceManagementPage;
